export const PlayIcon = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.50065 8.6224L9.00065 5.9974L5.50065 3.3724V8.6224ZM6.66732 0.164062C3.44732 0.164062 0.833984 2.7774 0.833984 5.9974C0.833984 9.2174 3.44732 11.8307 6.66732 11.8307C9.88732 11.8307 12.5007 9.2174 12.5007 5.9974C12.5007 2.7774 9.88732 0.164062 6.66732 0.164062ZM6.66732 10.6641C4.09482 10.6641 2.00065 8.5699 2.00065 5.9974C2.00065 3.4249 4.09482 1.33073 6.66732 1.33073C9.23982 1.33073 11.334 3.4249 11.334 5.9974C11.334 8.5699 9.23982 10.6641 6.66732 10.6641Z" />
  </svg>
);
